module.exports = __webpack_public_path__ + "img/35.f647cf90.jpg";